import { EventName } from '@lit/react';
import { BlocksDatepickerField } from 'blocks-nextjs/blocks-web-components/components/datepicker-field/datepicker-field';
import { BlocksCloseEvent, BlocksDatePickerChangeEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatDatepickerField = createComponent({
  react: React,
  tagName: 'cat-datepicker-field',
  elementClass: BlocksDatepickerField,
  events: {
    onBlDatePickerChange: 'bl-date-picker-change' as EventName<BlocksDatePickerChangeEvent>,
    onBlDatePickerOpen: 'bl-date-picker-open' as EventName<BlocksOpenEvent>,
    onBlDatePickerClose: 'bl-date-picker-close' as EventName<BlocksCloseEvent>
  }
});
